<template>
  <div class="filter-button">
    <div class="basic-btn" @click="openDropdown()">
      <h6>{{ _T('Price') }}</h6>
      <svg class="rightarrow" fill="none">
        <use xlink:href="#right-arrow-b" />
      </svg>
    </div>
    <div
      class="filter-content"
      :class="{ show: openPriceDropdown }"
      @mouseleave="closeDropdown()"
    >
      <div class="content-header d-flex d-sm-none">
        <h6>{{ _T('Price Range') }}</h6>
        <a
          href="javascript:void(0)"
          class="close-filter"
          @click="closeDropdown()"
        >
          <svg
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M18.7071 5.29289C19.0976 5.68342 19.0976 6.31658 18.7071 6.70711L6.70711 18.7071C6.31658 19.0976 5.68342 19.0976 5.29289 18.7071C4.90237 18.3166 4.90237 17.6834 5.29289 17.2929L17.2929 5.29289C17.6834 4.90237 18.3166 4.90237 18.7071 5.29289Z"
              fill="#3D3F43"
            ></path>
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289Z"
              fill="#3D3F43"
            ></path>
          </svg>
        </a>
      </div>
      <ul>
        <li
          v-for="(priceRange, key) in all_goorder_price_ranges"
          @click="selectPriceRange(priceRange)"
          :class="{ active: priceRange == selectedPriceRange }"
          :key="key"
        >
          {{ _T_DB(priceRange, 'name') }}
        </li>
      </ul>
      <div class="apply-btn d-none d-sm-block">
        <a href="javascript:void(0)" @click="Apply()" class="btn btn-solid">{{
          _T('Apply')
        }}</a>
      </div>
      <div class="content-footer d-block d-sm-none">
        <a
          href="javascript:void(0)"
          class="btn btn-outline"
          @click="closeDropdown()"
          >{{ _T('Back') }}</a
        >
        <a
          href="javascript:void(0)"
          class="btn btn-solid ml-15"
          @click="Apply()"
          >{{ _T('Apply') }}</a
        >
      </div>
    </div>
    <div class="mobile-overlay" :class="{ show: openPriceDropdown }"></div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Windowsize from '@/mixins/Windowsize'

export default {
  name: '',
  mixins: [Windowsize],
  data() {
    return {
      openPriceDropdown: false,
      selectedPriceRange: '',
    }
  },
  watch: {
    openPriceDropdown(newVal) {
      if (newVal) {
        document.body.style.setProperty('overflow', 'hidden')
      } else {
        document.body.style.removeProperty('overflow')
      }
    },
  },
  computed: {
    ...mapGetters(['all_goorder_price_ranges', '_T', '_T_DB']),
  },
  methods: {
    selectPriceRange(range) {
      if (range !== this.selectedPriceRange) {
        this.selectedPriceRange = range
      } else {
        this.selectedPriceRange = ''
      }
    },
    openDropdown() {
      this.openPriceDropdown = !this.openPriceDropdown
    },
    closeDropdown() {
      this.openPriceDropdown = false
    },
    mouseLeaveCloseDropdown() {
      if (this.windowSize > 575) {
        this.closeDropdown()
      }
    },
    Apply() {
      this.$store.commit('SET_SELECTED_PRICE_RANGE', this.selectedPriceRange)
      this.openPriceDropdown = false
    },
  },
}
</script>
